import { Grid, Paper, TextField } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SimulazioniSrlInputProps } from './DatiSimulazioniSrl';

export default function SoloDivSimulazioniSrl(props: SimulazioniSrlInputProps) {
    const gClasses = globalStyles();

    const { state } = props;

    return (
        <React.Fragment>
            <Paper className={gClasses.mainPaper}>
            <SectionTitle primary={true} text="3° Simulazione - società non trasparente - nessun compenso agli amministratori - distribuzione dividendi"></SectionTitle>
                <SectionTitle text="Società"></SectionTitle>
                <TextField
                    name="G48"
                    label="Ragione sociale"
                    value={state.datiSimulazioniSrl.G48}
                    className={gClasses.longTextFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <Grid container spacing={3}>
                    <Grid item>
                        <NumberField
                            name="K62"
                            label="Utile di bilancio al lordo dell'IRES"
                            value={state.datiSimulazioniSrl.K62}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K63"
                            label="Variazioni fiscali in aumento"
                            value={state.datiSimulazioniSrl.K63}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K64"
                            label="Variazioni fiscali in diminuzione"
                            value={state.datiSimulazioniSrl.K64}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I11"
                            label="Reddito d'impresa - fiscale"
                            value={state.soloDivSimulazioniSrl.I11}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I11"
                            label="Imponibile IRES"
                            value={state.soloDivSimulazioniSrl.I11}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I13"
                            label="IRES"
                            value={state.soloDivSimulazioniSrl.I13}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            special={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I14"
                            label="Utile di bilancio"
                            value={state.soloDivSimulazioniSrl.I14}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="D83"
                            label="Distribuzione di dividendi per complessivi euro"
                            value={state.datiSimulazioniSrl.D83}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                </Grid>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="1° Socio"></SectionTitle>
                <TextField
                    name="C52"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C52}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E118"
                        label="Pensione"
                        value={state.datiSimulazioniSrl.E118}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E119"
                        label="Lav. dipendente e assim."
                        value={state.datiSimulazioniSrl.E119}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E120"
                        label="Assimilati lav. dipendente"
                        value={state.datiSimulazioniSrl.E120}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E121"
                        label="Impr. minore/ Lav. auton."
                        value={state.datiSimulazioniSrl.E121}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E122"
                        label="Diversi lettere i) e l)"
                        value={state.datiSimulazioniSrl.E122}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E123"
                        label="Fabbricati locati"
                        value={state.datiSimulazioniSrl.E123}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E31"
                        label={"Dividendi (" + state.datiSimulazioniSrl.E111 + "%)"}
                        value={state.soloDivSimulazioniSrl.E31}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                    <NumberField
                        name="E124"
                        label="Altri"
                        value={state.datiSimulazioniSrl.E124}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E125"
                        label="Abitazione principale"
                        value={state.datiSimulazioniSrl.E125}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E127"
                        label="Redditi a cedolare secca"
                        value={state.datiSimulazioniSrl.E127}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E38"
                        label="Reddito complessivo"
                        value={state.soloDivSimulazioniSrl.E38}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E39"
                        label="Redd. compl. per detraz."
                        value={state.soloDivSimulazioniSrl.E39}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G23"
                        label="Redditi IVS"
                        value={state.soloDivSimulazioniSrl.G23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H23"
                        label="Contr. IVS"
                        value={state.soloDivSimulazioniSrl.H23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="I25"
                    label="Oneri deducibili"
                    value={state.soloDivSimulazioniSrl.I25}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I26"
                    label="Reddito imponibile"
                    value={state.soloDivSimulazioniSrl.I26}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I27"
                    label="Irpef lorda"
                    value={state.soloDivSimulazioniSrl.I27}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I29"
                    label="Familiari a carico"
                    value={state.soloDivSimulazioniSrl.I29}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I30"
                    label="Lavoro dipend."
                    value={state.soloDivSimulazioniSrl.I30}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I31"
                    label="Pensione"
                    value={state.soloDivSimulazioniSrl.I31}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I33"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={state.soloDivSimulazioniSrl.I33}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="L122"
                    label="Altre"
                    value={state.datiSimulazioniSrl.L122}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I35"
                    label="Tot. Detrazioni"
                    value={state.soloDivSimulazioniSrl.I35}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I37"
                    label="Irpef netta"
                    value={state.soloDivSimulazioniSrl.I37}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                {/* <NumberField
                    name="M25"
                    label="Quota dividendo"
                    value={state.soloDivSimulazioniSrl.M25}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                /> */}
                <Grid container>
                    <NumberField
                        name="K33"
                        label="Dividendi Imp.Sost."
                        value={state.soloDivSimulazioniSrl.K33}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="M33"
                        label="Imp.Sost."
                        value={state.soloDivSimulazioniSrl.M33}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K37"
                    label="Regionale"
                    value={state.soloDivSimulazioniSrl.K37}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M37"
                    label="Comunale"
                    value={state.soloDivSimulazioniSrl.M37}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="2° Socio"></SectionTitle>
                <TextField
                    name="C53"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C53}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E133"
                        label="Pensione"
                        value={state.datiSimulazioniSrl.E133}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E134"
                        label="Lav. dipendente e assim."
                        value={state.datiSimulazioniSrl.E134}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E135"
                        label="Assimilati lav. dipendente"
                        value={state.datiSimulazioniSrl.E135}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E136"
                        label="Impr. minore/ Lav. auton."
                        value={state.datiSimulazioniSrl.E136}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E137"
                        label="Diversi lettere i) e l)"
                        value={state.datiSimulazioniSrl.E137}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E138"
                        label="Fabbricati locati"
                        value={state.datiSimulazioniSrl.E138}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E62"
                        label={"Dividendi (" + state.datiSimulazioniSrl.E111 + "%)"}
                        value={state.soloDivSimulazioniSrl.E62}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                    <NumberField
                        name="E139"
                        label="Altri"
                        value={state.datiSimulazioniSrl.E139}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E140"
                        label="Abitazione principale"
                        value={state.datiSimulazioniSrl.E140}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E142"
                        label="Redditi a cedolare secca"
                        value={state.datiSimulazioniSrl.E142}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E69"
                        label="Reddito complessivo"
                        value={state.soloDivSimulazioniSrl.E69}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E70"
                        label="Redd. compl. per detraz."
                        value={state.soloDivSimulazioniSrl.E70}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G54"
                        label="Redditi IVS"
                        value={state.soloDivSimulazioniSrl.G54}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H54"
                        label="Contr. IVS"
                        value={state.soloDivSimulazioniSrl.H54}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="I56"
                    label="Oneri deducibili"
                    value={state.soloDivSimulazioniSrl.I56}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I57"
                    label="Reddito imponibile"
                    value={state.soloDivSimulazioniSrl.I57}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I58"
                    label="Irpef lorda"
                    value={state.soloDivSimulazioniSrl.I58}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I60"
                    label="Familiari a carico"
                    value={state.soloDivSimulazioniSrl.I60}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I61"
                    label="Lavoro dipend."
                    value={state.soloDivSimulazioniSrl.I61}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I62"
                    label="Pensione"
                    value={state.soloDivSimulazioniSrl.I62}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I64"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={state.soloDivSimulazioniSrl.I64}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="L137"
                    label="Altre"
                    value={state.datiSimulazioniSrl.L137}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I66"
                    label="Tot. Detrazioni"
                    value={state.soloDivSimulazioniSrl.I66}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I68"
                    label="Irpef netta"
                    value={state.soloDivSimulazioniSrl.I68}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                {/* <NumberField
                    name="M56"
                    label="Quota dividendo"
                    value={state.soloDivSimulazioniSrl.M56}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                /> */}
                <Grid container>
                    <NumberField
                        name="K64"
                        label="Dividendi Imp.Sost."
                        value={state.soloDivSimulazioniSrl.K64}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="M64"
                        label="Imp.Sost."
                        value={state.soloDivSimulazioniSrl.M64}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K68"
                    label="Regionale"
                    value={state.soloDivSimulazioniSrl.K68}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M68"
                    label="Comunale"
                    value={state.soloDivSimulazioniSrl.M68}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <SectionTitle primary={true} text="3° Socio"></SectionTitle>
            <Paper className={gClasses.mainPaper}>
                <TextField
                    name="C54"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C54}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E147"
                        label="Pensione"
                        value={state.datiSimulazioniSrl.E147}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E148"
                        label="Lav. dipendente e assim."
                        value={state.datiSimulazioniSrl.E148}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E149"
                        label="Assimilati lav. dipendente"
                        value={state.datiSimulazioniSrl.E149}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E150"
                        label="Impr. minore/ Lav. auton."
                        value={state.datiSimulazioniSrl.E150}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E151"
                        label="Diversi lettere i) e l)"
                        value={state.datiSimulazioniSrl.E151}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E152"
                        label="Fabbricati locati"
                        value={state.datiSimulazioniSrl.E152}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E93"
                        label={"Dividendi (" + state.datiSimulazioniSrl.E111 + "%)"}
                        value={state.soloDivSimulazioniSrl.E93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                    <NumberField
                        name="E124"
                        label="Altri"
                        value={Number(state.datiSimulazioniSrl.E153)} //E124 but it was an error
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E154"
                        label="Abitazione principale"
                        value={state.datiSimulazioniSrl.E154}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E156"
                        label="Redditi a cedolare secca"
                        value={state.datiSimulazioniSrl.E156}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E100"
                        label="Reddito complessivo"
                        value={state.soloDivSimulazioniSrl.E100}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E101"
                        label="Redd. compl. per detraz."
                        value={state.soloDivSimulazioniSrl.E101}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G85"
                        label="Redditi IVS"
                        value={state.soloDivSimulazioniSrl.G85}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H85"
                        label="Contr. IVS"
                        value={state.soloDivSimulazioniSrl.H85}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="I87"
                    label="Oneri deducibili"
                    value={state.soloDivSimulazioniSrl.I87}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I88"
                    label="Reddito imponibile"
                    value={state.soloDivSimulazioniSrl.I88}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I89"
                    label="Irpef lorda"
                    value={state.soloDivSimulazioniSrl.I89}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I91"
                    label="Familiari a carico"
                    value={state.soloDivSimulazioniSrl.I91}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I92"
                    label="Lavoro dipend."
                    value={state.soloDivSimulazioniSrl.I92}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I93"
                    label="Pensione"
                    value={state.soloDivSimulazioniSrl.I93}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I95"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={state.soloDivSimulazioniSrl.I95}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="L151"
                    label="Altre"
                    value={state.datiSimulazioniSrl.L151}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I97"
                    label="Tot. Detrazioni"
                    value={state.soloDivSimulazioniSrl.I97}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I99"
                    label="Irpef netta"
                    value={state.soloDivSimulazioniSrl.I99}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                {/* <NumberField
                    name="M87"
                    label="Quota dividendo"
                    value={state.soloDivSimulazioniSrl.M87}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                /> */}
                <Grid container>
                    <NumberField
                        name="K95"
                        label="Dividendi Imp.Sost."
                        value={state.soloDivSimulazioniSrl.K95}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="M95"
                        label="Imp.Sost."
                        value={state.soloDivSimulazioniSrl.M95}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K99"
                    label="Regionale"
                    value={state.soloDivSimulazioniSrl.K99}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M99"
                    label="Comunale"
                    value={state.soloDivSimulazioniSrl.M99}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
        </React.Fragment >
    )
}